// ページの枠（PC）（2026-10-21 に app.js から分けた）

// ---- ページの枠（PC）: 画面が高いときに、おすすめ・フッターまで画面に収めるための高さ ----
// 作る画面の高さは CSS（html.has-frame .app）で決める。ここでは下に続くおすすめ・フッターの高さを測って --page-below に入れる
// （言語で文字が折り返すと変わるので、大きさが変わるたびに測り直す）
export function fitPageFrame() {
  const below = [document.getElementById('recommend-area'), document.querySelector<HTMLElement>('.charat-footer')].filter(Boolean) as HTMLElement[];
  if (!below.length) return;
  const measure = () => {
    const h = below.reduce((sum, n) => sum + n.offsetHeight, 0);
    document.documentElement.style.setProperty('--page-below', h + 'px');
  };
  measure();
  if (window.ResizeObserver) { const ro = new ResizeObserver(measure); below.forEach((n) => { ro.observe(n); }); }
}
